<template>
  <div>
    <transition-group tag="div" class="fixed flex flex-col w-full inset-0 items-end px-4 py-6 pointer-events-none"
                      enter-active-class="transform ease-out duration-300 transition"
                      enter-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                      enter-to-class="translate-y-0 opacity-100 sm:translate-x-0"

                      leave-active-class="transform ease-out duration-500 transition"
                      leave-class="translate-y-0 opacity-100 sm:translate-x-0"
                      leave-to-class="translate-y-2 opacity-0 sm:translate-y-0 sm:translate-x-2"
                      style="z-index: 5000"
    >
      <simple-notify v-for="alert in alerts" :key="alert.id" :id="alert.id" :title="alert.title" :type="alert.type">
        <p class="text-sm leading-5 text-gray-500">{{ alert.text }}</p>
      </simple-notify>
    </transition-group>
    <component :is="layout">
      <router-view/>
    </component>
  </div>
</template>

<style>
</style>
<script>
import UserLayout from "@/layouts/UserLayout";
import SimpleNotify from "@/components/ui/notify/SimpleNotify";
import {mapGetters} from 'vuex';

export default {
  components: {SimpleNotify, UserLayout},
  data() {
    return {}
  },
  computed: {
    ...mapGetters('alerts', {alerts: 'all'}),
    layout() {
      return (this.$route.meta.layout || 'user') + '-layout'
    }
  },

  beforeMount() {
    this.$store.dispatch('initialiseStore');
  }
}
</script>